import React from 'react';
import ReactDOM from 'react-dom';

import './InfoPanel.scss';

import Directions from './Directions/Directions';
import SendToCell from './SendToCell/SendToCell';

import Api from '../../Helpers/Api';

const STATES = {
    HIDDEN: 0,
    DIRECTIONS: 1,
    SEND_TO_CELL: 2
}

export default class InfoPanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentState: STATES.HIDDEN,
            data: {
                dealer: {
                    address: props.dealerInfo.address,
                    hours: props.dealerInfo.hours,
                    remark: props.dealerInfo.remark
                },
                phoneCarrier: []
            }
        };

        this.changeState = this.changeState.bind(this);
    }

    componentDidMount() {
        Api.getCarrierInfo().then((res) => {
            var data = this.state.data;
            data.phoneCarrier = res.map(x => {
                return { label: x.name, value: x.id };
            });

            this.setState({
                data
            });
        });
    }

    render() {
        return (
            <div className={`info-panel ${this.state.currentState !== STATES.HIDDEN ? "active" : ""}`}>
                <header>
                    <span className={`cur-p ${this.state.currentState === STATES.DIRECTIONS ? "active" : ""}`} onClick={() => this.changeState(STATES.DIRECTIONS)}>Hours & Directions</span>
                    <span>&#124;</span>
                    <span className={`cur-p ${this.state.currentState === STATES.SEND_TO_CELL ? "active" : ""}`} onClick={() => this.changeState(STATES.SEND_TO_CELL)}>Send # to cell</span>
                </header>

                {(this.state.currentState !== STATES.HIDDEN &&
                    <CloseBtn
                        changeState={this.changeState}
                    />)}

                {(this.state.currentState === STATES.DIRECTIONS &&
                    <Directions
                        dealer={this.state.data.dealer}
                    />)}

                {(this.state.currentState === STATES.SEND_TO_CELL &&
                    <SendToCell
                        phoneCarrier={this.state.data.phoneCarrier}
                    />)}
            </div>
        );
    }

    changeState(state) {
        this.setState({
            currentState: state
        });
    }
}

function CloseBtn(props) {
    return (<div className="closeBtn" onClick={() => props.changeState(STATES.HIDDEN)}></div>);
}

let container = document.getElementById('info-panel');
let dealerInfo = {
    address: container.dataset.address,
    hours: JSON.parse(container.dataset.hours),
    remark: container.dataset.remark
};

ReactDOM.render(
    <InfoPanel
        dealerInfo={dealerInfo}
    />, container);


// WEBPACK FOOTER //
// ./Src/Shared/Header/InfoPanel/InfoPanel.jsx